import get from 'lodash/get';

export const ClientActivity = data => ({
  id: data.id,
  intervals: data.intervals || [],
});

export const responseDataToClientActivity = responseData => {
  return new ClientActivity({
    id: get(responseData, 'id'),
    intervals: get(responseData, 'attributes.intervals'),
  });
};

export const responseToClientActivity = response => {
  return responseDataToClientActivity(response.data.data);
};
